import React, {useEffect, useState} from 'react';
import authHeader from '../../helpers/jwt-token-access/auth-token-header';
import axios from 'axios';
import {
  Alert,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Row,
} from 'reactstrap';
import {useNavigate} from 'react-router-dom';
import DownloadFile from './downloadFile';
import {getLoggedInUser} from '../../helpers/fakebackend_helper';
import {DEALER_FLAG_NON_TEXTILE, DEALER_FLAG_TEXTILE} from '../../components/Dealer/DealerConst';

const DownloadArea = () => {
  const [items, setItems] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const [loading, setIsLoading] = useState(true);

  const navigate = useNavigate();
  const authUser = getLoggedInUser();

  const pathParts = window.location.pathname.split('/');
  const page = pathParts[2];
  const categoryId = pathParts.pop();

  const requiredFlag = page === 'non-textile' ? DEALER_FLAG_NON_TEXTILE : DEALER_FLAG_TEXTILE;

  if (!authUser.user.flags.includes(requiredFlag)) {
    navigate('/dashboard/');
  }

  useEffect(() => {
    getDownloads();
  }, [page]);

  function getDownloads() {
    const url = process.env.REACT_APP_APIURL + 'downloads';
    const authToken = authHeader();

    setIsLoading(true);
    setItems([]);

    return axios.get(url, {headers: authToken, params: {page: requiredFlag}}).then(
        (response) => {
          setIsLoading(false);
          setItems(response.data.data);
          if (categoryId > 0) {
            response.data.data.forEach(function(item) {
              const category = item.categories.items.find(
                  (category) => category.id === categoryId,
              );
              if (category) {
                setCurrentItem(item);
              }
            });
          }
        }).catch(() => {
      // setIsLoading(false);
    });
  }

  return (
    <React.Fragment>
      <Row className="page-content">
        <Container fluid>

          <Row>
            {items ? <Col xl="3">
              {items.map((item, itemIndex) =>
                <Card key={'item-' + itemIndex}>
                  <CardBody className="d-flex p-2 justify-content-between align-items-center cursor-pointer"
                    onClick={() => {
                      setCurrentItem(item);
                    }}>
                    <CardTitle
                      className="text-yellow m-0"
                    >
                      {item.folder.name}
                    </CardTitle>
                    <i className="bx bx-chevron-right fs-3 text-muted"></i>
                  </CardBody>
                </Card>)}
              <Card>
                <CardBody className="d-flex p-2 justify-content-between align-items-center cursor-pointer"
                  onClick={() => {
                    window.open('https://base.brother.digital/', '_blank');
                  }}>
                  <CardTitle className="text-yellow m-0">Downloads for Customer</CardTitle>
                  <i className="bx bx-link-external fs-3 text-muted"></i>
                </CardBody>
              </Card>
            </Col> : ''}

            <Col xl="9">
              <Card>
                <CardBody>
                  <CardTitle className="font-size-24 text-yellow mb-4">
                    {currentItem ?
                      currentItem.folder.name :
                      requiredFlag === DEALER_FLAG_NON_TEXTILE ? 'Downloads Non-Textile' : 'Downloads Textile'}
                  </CardTitle>
                  {currentItem &&
                    <Alert color="danger">
                      Please note the provided software-tools and manuals
                      are for dealer use only. Do not share them with
                      customers.
                    </Alert>}
                  {loading && <div className="d-flex mb-4">
                    <div><i className="bx bx-loader bx-spin mr-1"></i></div>
                    <div>Loading...</div>
                  </div>}
                </CardBody>
              </Card>
              {currentItem && currentItem.downloads.length === 0 &&
                <Card><CardBody>
                  <div className="text-muted">No files available</div>
                </CardBody></Card>
              }
              {currentItem && currentItem.categories.items.map(
                  (category, index) =>
                    <Card
                      key={'category-' + index}>
                      <CardBody>
                        <CardTitle className="text-yellow mb-4">
                          {category.name}
                        </CardTitle>
                        {currentItem && currentItem.downloads?.filter(
                            (download) => download.parent_id === category.id,
                        ).length > 0 ? (
                        currentItem && currentItem.downloads?.filter(
                            (download) => download.parent_id === category.id,
                        ).map(
                            (download, index) =>
                              <DownloadFile
                                className={
                                index > 0 ? 'mt-2 pt-4 border-top ' +
                                  'border-light border-top-1' : ''
                                }
                                key={`download-${index}`}
                                download={download}
                                index={index}
                              />,
                        )
                      ) : (
                        <div className="text-muted">No files available</div>
                      )}
                      </CardBody>
                    </Card>,
              )}
            </Col>
          </Row>
        </Container>
      </Row>
    </React.Fragment>
  );
};

export default DownloadArea;
